<template>
    <div class="flex items-center">
      <div class="flex w-full bg-white rounded shadow">
        <select class="relative px-6 py-3 w-full rounded-r focus:shadow-outline form-select" autocomplete="off" name="skuType" placeholder="Select SKU Types" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)">
          <option
            v-for="item in items"
            :key="item.id"
            :value="item.name"
          >
            {{ item.name }}
          </option>
        </select>
      </div>
      <button class="ml-3 text-gray-500 hover:text-gray-700 focus:text-indigo-500 text-sm" type="button" @click="$emit('reset')">Reset</button>
    </div>
  </template>
  
  <script>
  
  export default {
    props: {
      modelValue: String,
      maxWidth: {
        type: Number,
        default: 300,
      },
      items: Object,
    },
    emits: ['update:modelValue', 'reset'],
  }
  </script>
  